import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import "./styles.scss";

export interface IconButtonProps extends ComponentPropsWithoutRef<"button"> {
  active?: boolean;
  "aria-label": string;
  autoWidth?: boolean;
  className?: string;
  disabled?: boolean;
  noMargin?: boolean;
  tooltipPlacement?: "top" | "left" | "bottom" | "right";
  tooltipText?: string;
  variant?: "default" | "dark-background" | "labeled";
}

export const IconButton = ({
  active = false,
  autoWidth = false,
  children,
  disabled = false,
  noMargin = false,
  onClick,
  tooltipPlacement = "top",
  tooltipText,
  variant = "default",
  className = "",
  ...rest
}: IconButtonProps) => (
  <TippyV2
    placement={tooltipPlacement}
    content={tooltipText}
    enabled={Boolean(tooltipText) && !disabled}
    className="inline-block"
  >
    <button
      type="button"
      disabled={disabled}
      className={classNames(
        "icon-button focus-visible:!outline-secondary focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2",
        {
          "text-[#F0F3F5] hover:text-[#F7F9FA]": variant === "default",
          "light:text-dark light:hover:text-darkest dark:text-lightest dark:hover:text-light":
            variant === "dark-background",
          "flex !h-auto !w-auto gap-2 !px-4 !py-3": variant === "labeled",
          "!w-auto": autoWidth,
          "!mr-0": noMargin,
          "rounded-lg bg-[#34373D] text-[#F7F9FA]": active,
          "!cursor-not-allowed": disabled,
        },
        className,
      )}
      onClick={event => {
        if (disabled || !onClick) return;
        onClick(event);
      }}
      {...rest}
    >
      {children}
    </button>
  </TippyV2>
);
